import { get, patch } from "./api";

const accountSettingsService = {
  fetchAccount: (accountId) => get({ endpoint: `/account-settings/${accountId}` }),
  fetchSftpSettings: (accountId) => get({ endpoint: `/account-settings/${accountId}/sftp/settings` }),
  editAccount: (accountId, data) => patch({ endpoint: `/account-settings/${accountId}`, data })
};

export default accountSettingsService;
